/** Canonical casing for short words that should stay uppercase in dashboard titles. */
const DASHBOARD_WORD_ABBREVIATIONS: Record<string, string> = {
  ar: 'AR',
  kpi: 'KPI',
  ytd: 'YTD',
  hipaa: 'HIPAA',
}

/**
 * Sentence-case for dashboard section titles, table headers, breadcrumbs, and labels.
 * Capitalizes only the first word; later words are lowercased unless listed abbreviations.
 */
export function toDashboardSentenceCase(text: string): string {
  if (text.includes(' / ')) {
    return text
      .split(' / ')
      .map((segment) => toDashboardSentenceCase(segment.trim()))
      .join(' / ')
  }

  const parts = text.split(/(\s+)/)
  let capitalizedFirstWord = false

  return parts
    .map((part) => {
      if (/^\s+$/.test(part)) return part

      const lower = part.toLowerCase()
      const abbrev = DASHBOARD_WORD_ABBREVIATIONS[lower]
      if (abbrev) {
        capitalizedFirstWord = true
        return abbrev
      }

      if (!capitalizedFirstWord) {
        capitalizedFirstWord = true
        const idx = lower.search(/[a-z]/)
        if (idx === -1) return lower
        return (
          lower.slice(0, idx) +
          lower.charAt(idx).toUpperCase() +
          lower.slice(idx + 1)
        )
      }

      return lower
    })
    .join('')
}
